import { render, staticRenderFns } from "./UnRelClmDocHelpList.vue?vue&type=template&id=77557d47&"
import script from "./UnRelClmDocHelpList.vue?vue&type=script&lang=js&"
export * from "./UnRelClmDocHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports